module.exports = flarum.core.compat['LogInModal'];